"use client";

import React from "react";
import Questions from "@/components/main/questions";
import AboutMe from "@/components/main/about-me";
import ArtTherapy from "@/components/main/art-therapy";
import HowItWorks from "@/components/main/how-it-works";
import LatestEvents from "@/components/main/latest-events";
import { useNavigate, Link } from "react-router-dom";
import Organisations from "@/components/main/organisations";
import { HomeCarousel } from "@/components/main/HomeCarousel";

export default function Main() {
  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate(`/lelek-szinei`);
  };

  return (
    <div>
      <h1
        className="flex-2 md:min-w-2/3 mx-auto mb-10 mt-10 w-full text-center text-4xl leading-relaxed text-amber-800 text-opacity-80 md:w-2/3 font-medium italic"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >
        Művészetterápiás foglalkozások, life és art coaching, mentálhigiénés
        szolgáltatások, család- és rendszerállítási alkalmak
      </h1>
      <AboutMe />
      <LatestEvents />
      <HomeCarousel />
      <HowItWorks />
      <Questions />
      <ArtTherapy />

      <section className="beart-section flex w-3/4 flex-col">
        <Organisations />
        <Link
          to="/kapcsolat"
          className="mx-auto mt-8 flex w-full justify-center rounded-3xl p-4 text-orange-700 transition-colors duration-300 ease-in-out hover:bg-red-700 hover:text-white"
        >
          <div className="flex content-center p-4 text-center text-2xl font-bold">
            <div className="mr-2 flex gap-2">
              <i className="bi bi-hand-index-thumb animate-pulse animate-delay-75"></i>{" "}
              <i className="bi bi-cursor animate-pulse animate-delay-300"></i>
            </div>
            <div>
              Bővebb információért, egyéb mentálhigiénés és fejlesztői
              programokért, egyedi ajánlatokért keress bátran!
            </div>
          </div>
        </Link>
      </section>
    </div>
  );
}
